<script>

export default {
  components: {},
  props: {
    value: {
      type: Object,
      required: true
    }
  }
};
</script>

<template>
  <b-card no-body class="text-center">
    <b-card-body>
      <h5 class="font-size-15 mb-1">
        <span class="text-dark">{{ value }}</span>
      </h5>

      <blockquote>{{ value.Texte }}</blockquote>
    </b-card-body>
  </b-card>
</template>
